const Quality = Object.freeze({
  SIMPLE: 'SIMPLE',
  NORMAL: 'NORMAL',
  HIGH: 'HIGH',
  LUXURY: 'LUXURY'
})

export default Quality
